//---- React
//---- Ant Design
import { Table, Modal} from "antd";

//---- Project related
import { formatOnlyTime } from "components/Common/Utils";
import NoData from "components/Common/NoData";

const DataGrid = ({title, dataModalOpen, gridData, gridField, onCloseModal}) => {
      
    const formatColumns = () => {
        const cols = [
            {
                title: "timestamp",
                dataIndex: "timestamp",
                key: "timestamp",
                align: "left",
                width: 130,
            },
        ]
        return cols.concat(
          gridField?.map((field) => {
            return {
              title: field,
              dataIndex: field,
              key: field,
              align: "left",
              width: 130,
            };
          })
        );
    };

    const formatData = () => {
      const singleField = gridField.length === 1 ? true : false;

      const formattedData = singleField ?
        gridData?.map((dataItem, index) => {
          let rowObj = {};
          rowObj.timestamp = formatOnlyTime(dataItem[0])
          rowObj[gridField[0]]= dataItem[1]
          return rowObj;
        })
        :
        gridData?.map((dataItem, index) => {
        let rowObj = {};
        rowObj.timestamp = formatOnlyTime(dataItem?.timestamp)
        gridField?.forEach((field) => {
          rowObj = {
            ...rowObj,
            [field]: dataItem?.[field]
          }
        })
        return rowObj;
      });
      return formattedData;
    };
  
    return (
      <Modal
        title={gridField.length === 1 ? 
          'Data - ' + gridField[0] : title
        }
        open={dataModalOpen}
        closable={true}
        onCancel={onCloseModal}
        rowKey="key"
        footer={null}
        width={{ xs: '90%', sm: '80%', md: '75%', lg: '80%', xl: '90%', xxl: '90%', }}   
      >
        {
          <>
            <div>
              {gridData?.length ?
                  <Table 
                    dataSource={formatData()} 
                    columns={formatColumns()} 
                    pagination={false}
                    footer={null}
                    scroll={{ y: 500, x: 'max-content'}}
                  />
                :
                  <NoData/>
              }
            </div>
          </>
        } 
      </Modal>
    );
};

export default DataGrid;